/*
 * @Author: hfxie
 * @Date: 2022-08-17 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-06 17:23:06
 * @Description: 常量:交互自定义事件接口·服务的调用我·方法名
 */

const DEMO = "gtRefreshIniControlGanttData"; // 示例进来的常量方法名

const DATA_LOADING = "dataLoading"; // 初始化·主动发起数据加载
const INIT_APP = "init"; // 初始化数据

const InConst = {
  DEMO,

  DATA_LOADING,
  INIT_APP,

};

export default InConst;
